export default {
  state: {
    hyptoLoader: false,
    popupName: null,
    initialHistory: null,
    bankTransfer: null,
    searchValue: null,
    unprivilegePage: null,
    upcomingEventsCnt: 0,
    invalidResponseMsg: null,
    sectionDetails: null
  },
  mutations: {
    SET_HYPTO_LOADER: (state, payload) => {
      state.hyptoLoader = payload
    },
    SET_POPUP_NAME: (state, payload) => {
      state.popupName = payload
    },
    SET_INITIAL_HISTORY: (state, payload) => {
      state.initialHistory = payload
    },
    SET_BANK_TRANSFERRED: (state) => {
      state.bankTransfer = new Date()
    },
    SET_SEARCH_VALUE: (state, payload) => {
      state.searchValue = payload
    },
    SET_UNPRIVILEGE_PAGE: (state, payload) => {
      state.unprivilegePage = payload
    },
    SET_PREVIOUS_ROUTE: (state, payload) => {
      state.previousRoute = payload
    },
    SET_UPCOMING_EVENTS_COUNT: (state, payload) => {
      state.upcomingEventsCnt = payload
    },
    SET_INVALID_RESPONSE_MSG: (state, payload) => {
      state.invalidResponseMsg = payload
    },
    SET_SECTION_DETAILS: (state, payload) => {
      state.sectionDetails = payload
    }
  },
  getters: {
    isHyptoLoader: state => {
      return state.hyptoLoader
    },
    getterPopupName: state => {
      return state.popupName
    },
    getterBankTransferred: state => {
      return state.bankTransfer
    },
    getterSearchValue: state => {
      return state.searchValue
    },
    getterUnprivilegePage: state => {
      return state.unprivilegePage
    },
    getterPreviousRoute: state => {
      return state.previousRoute
    },
    getterUpcomingEventsCount: state => {
      return state.upcomingEventsCnt
    },
    getterInvalidResponseMsg: state => {
      return state.invalidResponseMsg
    },
    getterSectionDetails: state => {
      return state.sectionDetails
    }
  }
}
